import { WebSocketMessageTypeIncoming } from '../../../Enums/WebSocketMessageTypeIncoming';
import { WebSocketMessageTypeOutgoing } from '../../../Enums/WebSocketMessageTypeOutgoing';
import { TransputLogging } from '../../../Models/Logging/TransputLogging';

export class WsTransputLoggings {
  Type: WebSocketMessageTypeIncoming;
  ListItems: Array<TransputLogging> = new Array<TransputLogging>();

  constructor() {
    this.Type = WebSocketMessageTypeIncoming.WsTransputLoggings;
  }
}
